import { render } from "./HomepageCncd.vue?vue&type=template&id=2ae249dc&scoped=true"
import script from "./HomepageCncd.vue?vue&type=script&lang=js"
export * from "./HomepageCncd.vue?vue&type=script&lang=js"

import "./HomepageCncd.vue?vue&type=style&index=0&id=2ae249dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae249dc"]])

export default __exports__